import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import DatePicker from '../../date-picker';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    render({ number, date }) {
        if (number) {
            return (
                <daily-number-non-mobile>
                    <div class='daily-number'>
                        <img
                          src={`https://gfx.tarot.com/images/numerology/daily/${number.number}.jpg`}
                          alt='Daily Number'
                        />
                        <small>
                            Today's Numbers:&nbsp;
                            {number.numbers.map((num, key) => {
                                if (key == 0) {
                                    return num;
                                }

                                return `, ${num}`;
                            })}
                        </small>
                    </div>
                    <DatePicker class='icon-24x23-calendar js-datepicker' url='/daily-number/:date' />
                    {this.renderDailyLinks()}
                    <h1>Number of<br />the Day</h1>
                    <div class='daily-links'>
                        <a href='/bios/hans-decoz'>By Hanz Decoz</a>
                        <a href='/readings-reports/numerology'>View All Numerology Reports</a>
                    </div>
                    <br />
                    {number.body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p><b>{moment(date).format('M.D.YY')}: </b>{number.title}: {p}</p>
                            );
                        }
                        return (<p>{p}</p>);

                    })}
                    <p><PromoMessage placement='text-number' /></p>
                </daily-number-non-mobile>
            );
        }

        return (
            <daily-number-non-mobile>
                <div class='daily-number'>
                    <img
                      src='https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg'
                      alt='Daily Number'
                      class='number-unknown'
                    />
                </div>
                <DatePicker class='icon-24x23-calendar js-datepicker' url='/daily-number/:date' />
                {this.renderDailyLinks()}
                <h1>Number of<br />the Day</h1>
                <div class='daily-links'>
                    <a href='/bios/hans-decoz'>By Hanz Decoz</a>
                    <a href='/readings-reports/numerology'>View All Numerology Reports</a>
                </div>
                <br />
                <br />
                <h2>Your FREE Daily Number Awaits!</h2>
                <br />
                <p>
                    Looking for your Number of the Day? Create your profile to receive a number that's personalized
                    to YOU every day!
                </p>
                <p>
                    <a href='#login' class='button'>GET MY DAILY NUMBER</a>
                </p>
            </daily-number-non-mobile>
        );
    }

    renderDailyLinks = () => {
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const today = moment().format('YYYY-MM-DD');
        const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');

        return (
            <div class='daily-links'>
                <a href={`/daily-number/${yesterday}`} class={this.props.date == yesterday ? 'selected' : ''}>
                    Yesterday
                </a>
                <a href={`/daily-number/${today}`} class={this.props.date == today ? 'selected' : ''}>
                    Today
                </a>
                <a href={`/daily-number/${tomorrow}`} class={this.props.date == tomorrow ? 'selected' : ''}>
                    Tomorrow
                </a>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    number: state.number,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/daily/number/non-mobile.js